import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

export default function FAQAccordion({ items, defaultOpenIndex = 0 }) {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="space-y-4">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={index}
            className={`rounded-2xl transition-all duration-300 border overflow-hidden ${
              isOpen
                ? 'bg-white border-[#0F766E]/30 shadow-medium'
                : 'bg-white/70 hover:bg-white border-[#D9E8E5]'
            }`}
          >
            <button
              onClick={() => toggle(index)}
              className="w-full p-6 text-left flex items-start justify-between gap-4 focus:outline-none"
              aria-expanded={isOpen}
            >
              <span className="font-serif text-lg sm:text-xl text-[#123B5D] font-normal leading-snug">
                {item.question}
              </span>
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors duration-200 mt-0.5 ${
                  isOpen ? 'bg-[#0F766E] text-white' : 'bg-[#F5FAF9] text-[#0F766E]'
                }`}
              >
                {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
              </div>
            </button>

            {isOpen && (
              <div className="px-6 pb-6 pt-0 animate-in fade-in duration-200">
                <div className="pt-2 border-t border-[#D9E8E5]">
                  <p className="text-sm text-[#64748B] leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
